import { Component, OnInit } from '@angular/core';
import { User } from 'domain-models/User';
import { UserInfoService } from 'services/user-info/user-info.service';
const moment = require('moment');
type DisplayUser = User & {
	/**Extra property to allow full-text search */
	fullname?: string;
};
/**Default values for login date, meaning user never logged in */
const defaultDates = ['0001-01-01 00:00:00', '2001-01-01T06:00:00.000Z'];
@Component({
	selector: 'user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
	constructor(private userInfoService: UserInfoService) {}
	users: DisplayUser[] = [];
	ngOnInit(): void {
		// pass empty params to get full list of users
		this.userInfoService.getByValue('', '').subscribe(
			(users) => (this.users = this.mapUsers(users)),
			(err) => (this.users = [])
		);
	}
	mapUsers(users: DisplayUser[]): DisplayUser[] {
		return (users || []).map((usr) => {
			usr.fullname = `${usr.name} ${usr.lastname} ${usr.username}`;
			usr.last_login =
				//ignore records with invalid dates and default login date
				usr.last_login && !defaultDates.includes(usr.last_login) && moment(usr.last_login).isValid()
					? usr.last_login
					: '';
			return usr;
		});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/user-list/user-list.component.ts